import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Card } from '@/components/ui/card.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { IndexItem } from '@/types/index/index-list.type';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export function SpecialtyCityCard({
  specialty,
  isFirst = false,
}: {
  specialty: IndexItem;
  isFirst?: boolean;
}) {
  const keyUrl = `/especialidades/por-especialidade/${specialty?.slug}/${String(specialty.cities?.[0].state_abbr).toLowerCase()}/`;

  return (
    <Card
      className={`md:mt-6 pt-0 border-x-0 sm:px-16 ${isFirst ? 'border-t' : 'border-t-0'} md:px-6 md:border-t md:border-b md:border-x rounded-none md:rounded-xl`}
    >
      <Link
        prefetch={false}
        href={keyUrl}
        data-testid={DataTestIdEnum.INDEX_LINK_BY_HEADER_NAME}
        className="bg-green-100 hover:bg-green-200 text-gray-700 rounded-b w-fit flex items-center px-5 py-1 hover:underline"
        data-analytics-event={AnalyticsEnum.EXPAND_STATE_UF}
        data-analytics-properties={JSON.stringify({
          estado_nome: specialty.cities?.[0].state_abbr,
          especialidade: specialty.name,
        })}
      >
        <Typography
          variant={TypographyVariant.MEDIUM_BODY_TEXT}
          className="font-semibold"
        >
          {specialty.key}
        </Typography>
      </Link>

      <ul className="mt-4 space-y-4">
        {specialty?.cities?.map((city) => (
          <li key={city?.slug}>
            <Link
              prefetch={false}
              className="text-green-500 font-bold hover:underline"
              href={`/especialidades/${specialty?.slug}-em-${city?.slug}/`}
              data-testid={DataTestIdEnum.INDEXING_CARD_CITY_NAME}
              data-analytics-event={AnalyticsEnum.CLICK_SPECIALTY_BY_CITY}
              data-analytics-properties={JSON.stringify({
                especialidade: specialty.name,
                cidade: city?.city,
                estado_nome: city?.state_abbr,
              })}
            >
              {`${formatToTitleCase(String(specialty?.name))} em ${city?.city} - ${city?.state_abbr}`}
            </Link>
            {specialty?.cities?.length && specialty?.cities?.length > 1 && (
              <hr className="mt-4" />
            )}
          </li>
        ))}
      </ul>

      {specialty.cities?.length && specialty.cities?.length > 4 && (
        <Link
          prefetch={false}
          data-testid={DataTestIdEnum.INDEXING_CARD_SEE_MORE}
          data-analytics-key={specialty.key}
          href={keyUrl}
        >
          <Button
            variant="text"
            className="w-fit mt-4 font-bold"
            startIcon={faPlus}
            data-analytics-event={
              AnalyticsEnum.CLICK_SEE_MORE_BY_SPECIALTY_AND_UF
            }
            data-analytics-properties={JSON.stringify({
              estado_nome: specialty.cities?.[0].state_abbr,
              especialidade: specialty.name,
            })}
          >
            Ver mais
          </Button>
        </Link>
      )}
    </Card>
  );
}
